export const ZONE_NAME = 'Crimson Frontier';

export const LANDMARKS = Object.freeze([
  Object.freeze({ key: 'village', name: 'Crimson Rest', x: 500, y: 500, kind: 'village' }),
  Object.freeze({ key: 'south-fields', name: 'Ashen Fields', x: 460, y: -220, kind: 'hunt' }),
  Object.freeze({ key: 'east-wood', name: 'Wolfpine Wood', x: 1280, y: 520, kind: 'hunt' }),
  Object.freeze({ key: 'north-quarry', name: 'Dragon Quarry', x: 1120, y: 1390, kind: 'monolith' }),
  Object.freeze({ key: 'warden-arena', name: 'Warden Arena', x: 1710, y: 1610, kind: 'boss' })
]);

const houses = [
  [250, 350, 0.9], [420, 240, 1.05], [720, 300, 0.88], [790, 560, 1.08],
  [270, 680, 0.95], [540, 760, 1.15], [815, 790, 0.82]
];
const trees = [
  [-600, 120], [-440, 260], [-280, -160], [-70, -470], [180, -610], [770, -520],
  [1040, -280], [1170, 20], [1390, 240], [1510, 580], [1450, 830], [1620, 1040],
  [560, 1130], [260, 1260], [-80, 1080], [-340, 820], [-620, 600], [1050, 810],
  [1260, 970], [1480, 1240], [870, 1540], [360, 1610], [-240, 1430]
];

export const WORLD_PROPS = Object.freeze([
  ...houses.map(([x, y, scale], index) => Object.freeze({ key: `house-${index}`, kind: 'house', x, y, scale })),
  ...trees.map(([x, y], index) => Object.freeze({ key: `tree-${index}`, kind: 'tree', x, y, scale: 0.8 + (index % 4) * 0.1 })),
  Object.freeze({ key: 'gate-south', kind: 'gate', x: 510, y: 70, scale: 1 }),
  Object.freeze({ key: 'forge', kind: 'forge', x: 620, y: 470, scale: 1 }),
  Object.freeze({ key: 'fire-main', kind: 'campfire', x: 455, y: 510, scale: 1 }),
  Object.freeze({ key: 'fire-south', kind: 'campfire', x: 210, y: -120, scale: 0.75 }),
  Object.freeze({ key: 'monolith-visual', kind: 'monolith-clearing', x: 1120, y: 1390, scale: 1 }),
  Object.freeze({ key: 'warden-arena', kind: 'warden-arena', x: 1710, y: 1610, scale: 1 })
]);

export const MONOLITH_SPAWNS = Object.freeze([
  Object.freeze({ x: 1120, y: 1390 }),
  Object.freeze({ x: 1510, y: 1180 })
]);

export const BOSS_SPAWN = Object.freeze({ x: 1710, y: 1610 });

export function enemyTypeAt(x, y) {
  if (y > 850 || (x > 900 && y > 650)) return 'redTuskRaider';
  if (x > 850) return 'ridgeWolf';
  return 'ashHound';
}
